import * as React from "react";
import type { SVGProps } from "react";
const Cafe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4355_7381)">
      <g clipPath="url(#clip1_4355_7381)">
        <path
          fill="currentColor"
          d="M3.6 4.7996c0-.6637.5363-1.2 1.2-1.2h14.4c2.6513 0 4.8 2.1488 4.8 4.8 0 2.6513-2.1487 4.8-4.8 4.8H18c0 1.9875-1.6125 3.6-3.6 3.6H7.2c-1.9875 0-3.6-1.6125-3.6-3.6zm14.4 6h1.2c1.3238 0 2.4-1.0762 2.4-2.4s-1.0762-2.4-2.4-2.4H18zm-16.8 7.2h19.2c.6638 0 1.2.5363 1.2 1.2s-.5362 1.2-1.2 1.2H1.2c-.6637 0-1.2-.5362-1.2-1.2s.5363-1.2 1.2-1.2"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4355_7381">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="clip1_4355_7381">
        <path fill="transparent" d="M0 2.4004h24v19.2H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default Cafe;
